import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import AppLayout from "@/components/layout/AppLayout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import Bookings from "@/pages/Bookings";
import MealPlanWizard from "@/pages/MealPlanWizard";
import InHomeBooking from "@/pages/InHomeBooking";
import ChefBookings from "@/pages/ChefBookings";
import ChefEvents from "@/pages/ChefEvents";
import ChefMenus from "@/pages/ChefMenus";
import GroceryList from "@/pages/GroceryList";
import Messages from "@/pages/Messages";
import Profile from "@/pages/Profile";

function ChefGuard({ children }) {
  const { user } = useAuth();
  if (user?.role !== "chef") return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route element={<AppLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/events" element={<Events />} />
            <Route path="/events/:id" element={<EventDetail />} />
            <Route path="/bookings" element={<Bookings />} />
            <Route path="/meal-plans/new" element={<MealPlanWizard />} />
            <Route path="/in-home-booking" element={<InHomeBooking />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/chef/bookings" element={<ChefGuard><ChefBookings /></ChefGuard>} />
            <Route path="/chef/events" element={<ChefGuard><ChefEvents /></ChefGuard>} />
            <Route path="/chef/menus" element={<ChefGuard><ChefMenus /></ChefGuard>} />
            <Route path="/chef/grocery-list" element={<ChefGuard><GroceryList /></ChefGuard>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" richColors closeButton />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
